import { CellContext } from '@tanstack/react-table';
import { PackageStatus,Version } from 'common/contracts';
import { DATE_FORMAT } from 'constants/constants';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import Chip from 'components/Chip/Chip';

import { statusMapping } from '../utils';

const dayjsUTC = dayjs.extend(utc);

export function useColumns() {
  return [
    { accessorKey: 'versionName', header: 'Version Name' },
    { accessorKey: 'versionCode', header: 'Version Code' },
    { accessorKey: 'packageName', header: 'Package Name' },
    {
      accessorKey: 'versionStatuses',
      header: 'Status',
      cell: ({ row }: CellContext<Version, unknown>) => {
        const status = row.original.versionStatuses?.packageStatus || '';

        return (
          <Chip variant="flat" status={statusMapping[status as PackageStatus]}>
            {status}
          </Chip>
        );
      }
    },
    {
      accessorKey: 'createdAt',
      header: 'Creation Date',
      cell: (cell: CellContext<Version, unknown>) =>
        dayjsUTC.utc(cell.getValue() as boolean).format(DATE_FORMAT)
    }
  ];
}
